import GeneralPagination from "../GeneralPagination";
function EnquiryPagination() {
  return <GeneralPagination />;
}

export default EnquiryPagination;
